export function newEvent(event) {
  return {
    type: "NEW_EVENT",
    data: event
  };
}

export function editEvent(event) {
  return {
    type: "EDIT_EVENT",
    data: event
  };
}
export function hideModal() {
  return {
    type: "HIDE_EVENT_MODAL"
  };
}



// WEBPACK FOOTER //
// ./src/actions/events.js